import { styled } from '@mui/material';

import { Box, Button, Form, Stack, Text, TextInput } from 'shell/components';

const NameInputs = ({
    loading,
    device = 'desktop',
    isLastStep = false,
    form,
    errors,
    handleChange,
    handleNext,
    PAGES,
}) => {
    return (
        <NameBox device={device}>
            <Stack alignItems={'center'} spacing={1} sx={{ marginBottom: 6 }}>
                <Text variant={'h6'} weight={'medium'}>
                    Email Has Been Verified!
                </Text>
                <Text variant={'p1'} align={'center'}>
                    Welcome to TimelyGrader! Now that your email is verified, let’s set up your profile!
                </Text>
            </Stack>
            <Form onSubmit={() => handleNext(PAGES.NEW_PASSWORD)}>
                <InputStack direction={'column'} spacing={4}>
                    <Stack direction={device === 'desktop' ? 'row' : 'column'} spacing={4}>
                        <TextInput
                            data-cy={'account-creation-firstname'}
                            error={Boolean(errors.firstName)}
                            helperText={errors.firstName}
                            label={'First Name'}
                            onChange={(e) => handleChange('firstName', e.target.value)}
                            placeholder={'Enter your first name'}
                            value={form.firstName}
                            required
                        />
                        <TextInput
                            data-cy={'account-creation-lastname'}
                            error={Boolean(errors.lastName)}
                            helperText={errors.lastName}
                            label={'Last Name'}
                            onChange={(e) => handleChange('lastName', e.target.value)}
                            placeholder={'Enter your last name'}
                            value={form.lastName}
                            required
                        />
                    </Stack>
                    <Stack>
                        <TextInput
                            error={Boolean(errors.preferredName)}
                            helperText={errors.preferredName}
                            label={'Preferred Name'}
                            onChange={(e) => handleChange('preferredName', e.target.value)}
                            value={form.preferredName}
                            placeholder={'Enter name'}
                        />
                    </Stack>
                </InputStack>

                <ButtonStack direction={'row'} justifyContent={'space-between'}>
                    <div />
                    <Button loading={loading} data-cy={'account-creation-next-button'} size={'medium'} type={'submit'}>
                        {isLastStep ? 'Complete' : 'Next'}
                    </Button>
                </ButtonStack>
            </Form>
        </NameBox>
    );
};

const NameBox = styled(Box)(({ theme, device }) => {
    return {
        marginTop: theme.spacing(12),
        padding: device === 'mobile' ? 0 : theme.spacing(7),
        width: device === 'mobile' ? '100%' : 450,
        height: 'fit-content',
        background: device === 'mobile' ? 'transparent' : theme.palette.ensightful.shades[0],
        boxShadow: device === 'mobile' ? 'none' : theme.palette.ensightful.shadows[1],
        borderRadius: '12px',
    };
});

const InputStack = styled(Stack)(({ theme }) => {
    return {
        margin: theme.spacing(6, 0, 2, 0),
    };
});

const ButtonStack = styled(Stack)(({ theme }) => {
    return {
        flexDirection: 'row',
        margin: theme.spacing(6, 0, 3, 0),
        justifyContent: 'space-between',
    };
});

export default NameInputs;
